import { PrefectureId } from '@gyym/sdk'

import { usePrefectures } from '@/modules/Prefectures'

import { useFacilitiesMeta } from './useFacilitiesMeta'

export const useFacilitiesMetaPrefecture = (id?: PrefectureId) => {
  const { data } = useFacilitiesMeta()

  const metaPrefecture = data?.prefectures.find((pref) => pref.id === id)

  const shouldFetch = id && !metaPrefecture
  const { data: prefectures } = usePrefectures(shouldFetch)

  const prefecture = prefectures?.find((pref) => pref.id === id)

  return metaPrefecture || prefecture
}
